const SvgSecurity2 = (props) => (
  <>
    <defs />
    <path
      d="M32 0v215.87C32 308.34 104 384 192 384s160-75.66 160-168.13V0H32Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      id="b"
      d="M96 0v217.34C96 270.16 139.2 320 192 320s96-49.84 96-102.66V0"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={96} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={96} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={192} cy={320} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={192} cy={320} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={288} r={8} fill="#1e62f5" strokeWidth={0} />
    <circle cx={288} r={24} stroke="#021d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgSecurity2;
